<template>
  <div class="row calculate-price" v-if="!!product">
    <div class="col">
      <div class="row">
        <div class="col d-flex operation-table-actions align-items-center justify-content-start">
          <router-link
            v-if="isAddAgent"
            class="btn btn-back btn-lg"
            :to="`/ad-agent/calculate/product-select/${printMachineId}`"
            tag="button"
          >
            <i class="fa fa-angle-left px-1"></i>
          </router-link>
          <router-link
            v-else
            class="btn btn-back btn-lg"
            :to="`/calculate/product-select/${printMachineId}`"
            tag="button"
          >
            <i class="fa fa-angle-left px-1"></i>
          </router-link>
          <h2 class="ml-4">{{printMachine ? printMachine.name : ''}} / Подсчет стоимости</h2>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <h2 class="text-center">{{product.name.toUpperCase()}}</h2>
          <div class="section-details mt-4" v-for="section in sections" :key="section.id">
            <div
              class="section-details__header d-flex align-items-center justify-content-between px-4"
            >
              <h3>{{section.name}}</h3>
              <div>
                <i
                  class="section-details__header-toogle fa fa-minus cursor-pointer mr-2"
                  @click="toogleSection(section)"
                  v-if="section.visible"
                ></i>
                <i
                  class="section-details__header-toogle fa fa-plus cursor-pointer mr-2"
                  @click="toogleSection(section)"
                  v-else
                ></i>
              </div>
            </div>
            <template v-if="section.visible">
              <div
                class="section-details__block m-4 p-2"
                v-for="block in section.blocks"
                :key="block.id"
              >
                <div class="section-details__block-header px-2">
                  <div class="d-flex align-items-center justify-content-between">
                    <h6>{{block.name}}</h6>
                    <i
                      v-tooltip="block.description"
                      v-if="block.description"
                      class="section-details__block-question fa fa-question-circle"
                    ></i>
                    <span v-else></span>
                  </div>
                  <CalculatePriceBlock :block="block" />
                </div>
              </div>
              <div
                class="section-details__quantity d-flex align-items-center m-4 p-2"
                v-if="section.blocks.some(x=>x.algorithm.id === 8)"
              >
                <span class="mr-3">Укажите количество видов</span>
                <input
                  placeholder="количество"
                  type="text"
                  autocomplete="off"
                  class="form-control w-50"
                  v-model="section.quantity"
                />
              </div>
              <div
                class="section-details__quantity d-flex align-items-center m-4 p-2"
                v-if="section.blocks.some(x=>x.algorithm.id === 12 || x.algorithm.id === 14)"
              >
                <span class="mr-3">Укажите количество страниц</span>
                <input
                  placeholder="количество"
                  type="text"
                  autocomplete="off"
                  class="form-control w-50"
                  v-model="section.quantity"
                />
              </div>
            </template>
          </div>
          <div class="w-75 d-flex mt-3">
            <input
              placeholder="тираж"
              type="text"
              autocomplete="off"
              class="form-control w-50"
              v-model="printing"
              @keypress.enter="calculate"
            />
            <button type="button" class="btn btn-primary ml-2" @click="calculate">подсчитать</button>
          </div>
          <div v-for="(result, index) in calculateResult" :key="index">
            <p class="w-75 d-flex align-items-center mt-3" v-if="getCost(result)">
                <b>{{result.printMachineName}}:</b>
                <b class="ml-2">{{getCost(result).toFixed(2)}}</b>
                <span class="section-details__price ml-1">(за единицу {{(getCost(result) / fixedPrinting).toFixed(4)}})</span>
              <button class="btn btn-outline-primary btn-sm ml-2" @click="addItemToCard(index)">
                <i class="ico ico-plus mr-2"></i>
                в корзину
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../../api'
import CalculatePriceBlock from './CalculatePriceBlock'
import roles from '../../../helpers/userRoles'
import { mapActions } from 'vuex'
export default {
  name: 'CalculatePrice',
  components: { CalculatePriceBlock },
  props: {
    printMachineId: {
      default: null
    },
    productId: {
      default: null
    }
  },
  data: () => {
    return {
      product: null,
      sections: [],
      storedSections: [],
      printing: null,
      fixedPrinting: null,
      calculateResult: null,
      orientations: { long: 'По длинной стороне', short: 'По короткой стороне' },
      printMachine: null
    }
  },
  methods: {
    toogleSection (section) {
      const sectionIndex = this.sections.findIndex(x => x === section)
      const newSection = {
        ...this.storedSections[sectionIndex],
        visible: !section.visible
      }
      this.saveSectionVisibility({
        id: newSection.id,
        visible: newSection.visible
      })
      section = JSON.parse(JSON.stringify(newSection))
      this.sections.splice(sectionIndex, 1, section)
    },
    calculate () {
      this.fixedPrinting = +this.printing
      const resultSelections = this.sections.map(this.getResultSelections)
      const result = {
        current_pmid: this.printMachineId,
        current_pid: this.productId,
        printing: this.printing,
        checked_items: resultSelections
      }
      this.calculateResult = null
      api.post.printMachineCalculate(result).then(resp => {
        this.calculateResult = resp.data.data.results || null
        this.$nextTick(() => {
          window.scrollTo(
            0,
            document.body.scrollHeight || document.documentElement.scrollHeight
          )
        })
      }).catch((ex) => {
        if (ex && ex.response && ex.response.status === 400) {
          if (ex.response.data && ex.response.data.errors.indexOf('The limit has been exceeded.') >= 0) {
            this.$notify({
              message: ' Превышен лимит расчетов в сутки',
              type: 'danger'
            })
          }
        }
      })
    },
    getResultSelections (section) {
      const resultBlockSelection = section.blocks.map(
        this.getResultBlockSelection
      )

      resultBlockSelection.push({ quantity: section.quantity })

      return resultBlockSelection
    },
    getResultBlockSelection (block) {
      if (block.selectedFormat) {
        return { format: block.selectedFormat }
      }

      if (block.operation) {
        const selectedOperationData = this.getSelectedOperationData(
          block.operation
        )
        if (selectedOperationData) {
          if (block.selectedOperationCounter) {
            selectedOperationData.param = {
              ...selectedOperationData.param,
              count: block.selectedOperationCounter
            }
          }
          if (block.selectedOperationCounter) {
            selectedOperationData.param = {
              ...selectedOperationData.param,
              count: block.selectedOperationCounter
            }
          }
          if (block.selectedProcessingSides) {
            selectedOperationData.param = {
              ...selectedOperationData.param,
              processing_sides: block.selectedProcessingSides
            }
          }
          return { operation: selectedOperationData }
        }
        return
      }

      if (block.selectedOrientation) {
        return { orientation: block.selectedOrientation }
      }

      if (block.freeblock) {
        return { freeblock: block.freeblock }
      }
    },
    getSelectedOperationData (operation) {
      if (operation.children && operation.children.some(x => x.isSelected)) {
        return this.getSelectedOperationData(
          operation.children.find(x => x.isSelected)
        )
      }

      if (operation.isSelected) {
        const result = { id: operation.id }
        if (operation.selectedPreset) {
          result.param = {}
          result.param.name = operation.selectedPreset.yaxis
          result.param.size = [
            operation.selectedPreset.rigWidth,
            operation.selectedPreset.rigHeigh
          ]
        }
        return result
      }
    },
    sectionsMap (section) {
      section.blocks = section.blocks.filter(
        x => typeof x.operation === 'undefined' || x.operation.enabled
      )

      section.visible =
        typeof this.$store.getters.sectionsVisibility[section.id] ===
        'undefined'
          ? true
          : this.$store.getters.sectionsVisibility[section.id]
      return section
    },
    calculatedTechCard (calculateResult) {
      const result = []
      if (this.getCost(calculateResult) > 0) {
        result.push(`Печатная машина: ${calculateResult.printMachineName}`)
        result.push(`Продукт: ${calculateResult.result.productName}`)
        this.sections.forEach(section => {
          result.push(`Раздел: ${section.name}`)
          section.blocks.forEach(block => {
            const blockName = block.name ? `${block.name}: ` : ''
            let blockInfo = ''
            if (block.selectedFormat) {
              blockInfo = `${block.selectedFormat.width} x ${block.selectedFormat.height}`
            }
            if (block.selectedOrientation) {
              blockInfo = `${this.orientations[block.selectedOrientation]}`
            }
            if (block.operation) {
              let blockOperation = block.operation
              while (blockOperation && blockOperation.isSelected) {
                blockInfo += ` ${blockOperation.name}`
                if (blockOperation.selectedPreset) {
                  if (blockOperation.selectedPreset.yaxis) {
                    blockInfo += ` ${blockOperation.selectedPreset.yaxis} `
                  }
                  if (
                    blockOperation.selectedPreset.rigWidth ||
                    blockOperation.selectedPreset.rigHeigh
                  ) {
                    if (blockOperation.preset.extra_rig100) {
                      blockInfo += ` ,приладка: ${blockOperation.selectedPreset.rigWidth} x ${blockOperation.selectedPreset.rigHeigh}`
                    }

                    if (blockOperation.preset.width) {
                      blockInfo += ` ,размер материала: ${blockOperation.selectedPreset.rigWidth} x ${blockOperation.selectedPreset.rigHeigh}`
                    }
                  }
                }
                blockOperation = blockOperation.children
                  ? blockOperation.children.find(x => x.isSelected)
                  : null
              }
            }
            if (block.selectedOperationCounter && blockInfo) {
              blockInfo += ` ,количество: ${block.selectedOperationCounter}`
            }
            if (blockInfo) {
              result.push(blockName + blockInfo)
            }
          })
          if (
            section.blocks.some(
              x => x.algorithm.id === 12 || x.algorithm.id === 14
            )
          ) {
            result.push(`Количество страниц: ${section.quantity}`)
          }
          if (section.blocks.some(x => x.algorithm.id === 8)) {
            result.push(`Количество видов: ${section.quantity}`)
          }
          result.push('\n')
        })
        result.push(`Тираж: ${this.printing}`)
        result.push(`Цена: ${(+calculateResult.result.cost).toFixed(2)}`)
      }
      return result
    },
    addItemToCard (index) {
      api.get.addToBasket(index).then(() => {
        this.updateCard()
      })
    },
    getCost (calculateResult) {
      return calculateResult && calculateResult.cost
        ? +calculateResult.cost
        : 0
    },
    ...mapActions({
      updateCard: 'UPDATE_CARD',
      saveSectionVisibility: 'SAVE_SECTION_VISIBILITY'
    })
  },
  computed: {
    isAddAgent () {
      return this.$store.getters.role === roles.adAgent
    }
  },
  created () {
    api.get
      .printMachineProduct(this.printMachineId, this.productId)
      .then(resp => {
        this.product = resp.data.data.product
      })
    api.get
      .printMachineProductSections(this.printMachineId, this.productId)
      .then(resp => {
        this.sections = resp.data.data.sections.map(this.sectionsMap)
        this.storedSections = JSON.parse(JSON.stringify(this.sections))
      })
    api.get.printMachine(this.printMachineId).then(resp => {
      this.printMachine = resp.data.data.printMachine
    })
  }
}
</script>

<style lang="scss" scoped>
.section-details {
  border-radius: 4px;
  border: 1px solid #dbe1e5;
  background-color: #f9f9f9;

  &__header {
    height: 40px;
    background-color: #ebeff1;
    h3 {
      margin: 0;
    }

    &-toogle {
      font-size: 18px;
    }
  }

  &__block {
    background-color: #fff;
    border: 2px dashed #dbe1e5;
    border-radius: 3px;

    &-question {
      color: #28bd8b;
      font-size: 20px;
      cursor: pointer;
    }
  }

  &__price{
    color: #898c8f;
    font-size: 12px;
    font-weight: 700;
    line-height: 15px;
  }
}

.fa-info-circle {
  color: #28bd8b;
  cursor: pointer;
  font-size: 18px;
}
</style>
